export const Error = () => {
  return <div>Error - page not found.</div>;
};
